import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SignStockEditRequest } from '../../../../model/sign-stock/sign-stock-edit-request';
import {
  SignFrame,
  SignFramesChoiceArray,
} from '../../../../model/sign/enums/sign-frame';
import {
  SignLocationType,
  SignLocationTypesChoiceArray,
  SignLocationTypesChoices,
} from '../../../../model/sign-stock/sign-location-type';
import { cloneDeep } from 'lodash';
import { SignStockControllerRequestService } from '../../../../services/api/sign-stock-controller-request.service';
import { SnackService } from '../../../../services/snack.service';
import { SignDetail } from '../../../../model/sign/sign-detail';

@Component({
  selector: 'sign-stock-edit-request',
  templateUrl: './sign-stock-edit-request.component.html',
  styleUrls: ['./sign-stock-edit-request.component.scss'],
})
export class SignStockEditRequestComponent implements OnInit {
  @Input()
  sign: SignDetail;
  @Input()
  editRequest: SignStockEditRequest;
  @Input()
  isStockItemEditable: boolean = false;

  @Output()
  stockEdited = new EventEmitter<SignStockEditRequest>();

  frameChoices: SignFrame[];
  locationTypeChoices: SignLocationType[];

  readonly PHYSICAL_LOCATION: SignLocationType =
    SignLocationTypesChoices.PHYSICAL;

  constructor(
    private signStockControllerRequestService: SignStockControllerRequestService,
    private snackService: SnackService
  ) {}

  ngOnInit(): void {
    this.frameChoices = cloneDeep(SignFramesChoiceArray);
    this.frameChoices.unshift(null as any);

    this.locationTypeChoices = SignLocationTypesChoiceArray;
  }

  save(): void {
    if (!this.validToSave()) {
      return;
    }

    //Invert for negative amounts
    const requestToSend: SignStockEditRequest = cloneDeep(this.editRequest);
    if (
      this.editRequest.locationType.value ===
      SignLocationTypesChoices.PENDING_ORDER.value
    ) {
      requestToSend.amountIncrease *= -1;
    }

    this.signStockControllerRequestService
      .editStock(requestToSend)
      .then(() => {
        this.snackService.showSuccess('Stock succesvol aangepast');
        this.stockEdited.emit(requestToSend);
      })
      .catch((error) => {
        // Handle validation errors from the backend
        console.error('Stock edit error:', error);

        // Use the backend's error message if available, otherwise show a generic message
        if (error && error.error && error.error.message) {
          this.snackService.showError(error.error.message);
        } else {
          this.snackService.showError(
            'Er is een onverwachte fout opgetreden bij het aanpassen van de stock. Probeer het opnieuw of neem contact op met de beheerder.'
          );
        }
      });
  }

  validToSave(): boolean {
    if (this.editRequest.signId == null) {
      return false; //this shouldn't be possible to reach in practice
    }
    if (this.editRequest.locationType == null) {
      this.snackService.showError('Gelieve een locatie type te specifiëren');
      return false;
    }
    if (this.editRequest.locationType === this.PHYSICAL_LOCATION) {
      if (this.editRequest.rack == null) {
        this.snackService.showError('Gelieve een rek te specifiëren');
        return false;
      }
      if (this.editRequest.shelf == null) {
        this.snackService.showError('Gelieve een schap te specifiëren');
        return false;
      }
      if (this.editRequest.compartment == null) {
        this.snackService.showError('Gelieve een vaknummer te specifiëren');
        return false;
      }
    }

    if (this.editRequest.amountIncrease == null) {
      this.snackService.showError('Gelieve een toename te specifiëren');
      return false;
    }

    return true;
  }

  compareFrame(o1: SignFrame, o2: SignFrame): boolean {
    if (o1 == null && o2 == null) {
      return true;
    } else if (o1 != null && o2 != null) {
      if (o1.value === o2.value) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  compareLocationType(o1: SignLocationType, o2: SignLocationType): boolean {
    if (o1 == null && o2 == null) {
      return true;
    } else if (o1 != null && o2 != null) {
      if (o1.value === o2.value) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
}
